import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import VirtualizedSelect from 'react-virtualized-select'
import Select from 'react-select'
import { requestInventoryLocations } from '../../current/actions'
import { buildInventoryLocationOptionsIndex } from '../../current/selectors'
import { AppState } from '../../store'
import config from '../../config'

interface Props {
  value: any
  onChange: (any) => void
  className?: string
  autoload?: boolean
  includeLabel?: boolean
  disabled?: boolean
  skipIndex?: boolean
  includeBlankOption?: boolean
}

const createSelectOptions = (inventoryLocations: any, includeBlankOption: boolean) => {
  if (includeBlankOption) return [{ value: -1, label: '(No location)' }].concat(inventoryLocations)
  return inventoryLocations
}

export const IndexedInventoryLocationSelect = (props: Props) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (config.TEST) {
      return
    }

    // re-index the input every time, but load cached result from current
    if (props.autoload) dispatch(requestInventoryLocations())
  }, [dispatch, props.autoload])

  const { loading, values } = useSelector((s: AppState) => s.current.inventoryLocationOptions)
  const filterOptionsFunction = useSelector(buildInventoryLocationOptionsIndex)

  const onFocus = React.useCallback(
    () => !props.autoload && dispatch(requestInventoryLocations()),
    [dispatch, props.autoload]
  )

  const options = React.useMemo(
    () => createSelectOptions(values, props.includeBlankOption),
    [values, props.includeBlankOption]
  )

  const Component = config.TEST ? Select : VirtualizedSelect

  return (
    <Component
      value={props.value}
      onChange={props.onChange}
      className={props.className}
      simpleValue={!props.includeLabel}
      disabled={props.disabled}
      onFocus={onFocus}
      loading={loading}
      options={options}
      filterOptions={props.skipIndex ? undefined : filterOptionsFunction}
      noResultsText={loading ? 'Loading...' : 'No results'}
      placeholder={loading ? 'Loading...' : 'Select...'}
      isLoading={loading}
    />
  )
}
